import { HERO_ROTATION_MS, HERO_SLIDES } from "@/config/heroSlides";

export function initHeroRotation(lang: "pt" | "en"): () => void {
  const hero = document.getElementById("static-hero");
  if (!hero) return () => {};

  const slides = hero.querySelectorAll<HTMLImageElement>(".hero-slide");
  if (slides.length <= 1) return () => {};

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReducedMotion) return () => {};

  let activeIndex = 0;

  const setActive = (index: number) => {
    slides.forEach((slide, i) => {
      const isActive = i === index;
      slide.classList.toggle("is-active", isActive);
      if (isActive) {
        slide.setAttribute("aria-hidden", "false");
        const slideConfig = HERO_SLIDES[i];
        if (slideConfig) slide.alt = slideConfig.alt[lang];
      } else {
        slide.setAttribute("aria-hidden", "true");
      }
    });
    activeIndex = index;
  };

  const timer = window.setInterval(() => {
    setActive((activeIndex + 1) % slides.length);
  }, HERO_ROTATION_MS);

  setActive(0);

  return () => window.clearInterval(timer);
}
